module.exports = __webpack_public_path__ + "img/menu.a8d12544.svg";